import React, { Component } from 'react';

class VideoModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      whichVideo: props.videoId,
      videoUrl1: 'https://my.te.ge/uploads/Videos/video1.mp4',
      videoUrl2: 'https://my.te.ge/uploads/Videos/video2.mp4',
      currentVideoUrl: '',
    };
    this.videoRef = React.createRef();
  }

  componentDidMount() {
    //playVideo();
    this.videoRef.current.play();
  }

  playVideo = () => {
    this.videoRef.current.play();
  };

  pauseVideo = () => {
    this.videoRef.current.pause();
  };

  // Method to update the video URL dynamically
  setVideoUrl = (url) => {
    this.setState({ videoUrl: url }, () => {
      // Reload and autoplay the new video
      this.videoRef.current.load();
      this.videoRef.current.play();
    });
  };

  render() {
    const videoUrl = this.state.whichVideo === 1 ? this.state.videoUrl1 : this.state.videoUrl2;
    return (
      <>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <video ref={this.videoRef} width="80%" controls>
            <source src={videoUrl} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      </>
    );
  }
}

export default VideoModal;
